import ApiProvider from '../../../../core/api/ApiProvider'

class ProductTilesApi {
    public async getProductTiles(): Promise<any> {
        return await ApiProvider.get<any>('api/ProductTiles/getTiles');
    }
}

export default new ProductTilesApi();